import { render } from "./SpecialAdcategory.vue?vue&type=template&id=a8349210"
import script from "./SpecialAdcategory.vue?vue&type=script&lang=js"
export * from "./SpecialAdcategory.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__